<div class="list-picker">
	<label> {{ title }}{{ addKeyIconToLabel ? "  &#x1F511;  " : "" }} </label>
	<label class="toggleLabel">
		{{ toggleTitle }}
	</label>
	<div class="list-picker-List">
		<div class="list-picker-list-innerPadding">
			@for (entry of list | async; track entry) {
				<div
					class="mep-list-entry"
					[ngClass]="{
						'disabled-chip': disabled,
						'no-pp': !profilePicture || imgFallback,
						'profile-view-entry': showProfileViewButton,
						'transfer-to-project-entry': showProfileViewButton && showTransferToProjectButton,
						status: possibleSelection.length > 0
					}"
				>
					<!--suppress HtmlRequiredAltAttribute -->
					@if (profilePicture && !imgFallback) {
						<img
							[src]="profilePicture(entry.original, profilePictureLink, profilePictureFallback)"
							(error)="imgFallback = true"
						/>
					}
					<div class="entry_information">
						<div class="first-column">
							@if (entry.original.id && showSkillsOfEmployee && profilePicture) {
								<div
									(mouseenter)="openPopover(popover, entry.original.id)"
									(mouseleave)="closePopover(popover, entry.original.id)"
								>
									<div
										#popover="mepPopover"
										[mepPopover]="popSkill"
										[mepPopoverConfig]="{placement: 'left', trigger: 'manual', autoClose: false, popoverClass: 'ngb-popover-border'}"
									>
										<div>
											{{ entry.firstColumn }}
										</div>
										<ng-template #popSkill>
											<div
												(mouseenter)="cancelClosePopover(entry.original.id)"
												(mouseleave)="closePopover(popover, entry.original.id)"
											>
												@if (skillDbHoveredEmployeeId === entry.original.id) {
													<app-skill-db-list
														[includeNoSkillsMessage]="true"
														[employeeId]="skillDbHoveredEmployeeId"
													></app-skill-db-list>
												}
											</div>
										</ng-template>
									</div>
								</div>
							}
							@if (!showSkillsOfEmployee || !entry.original.id) {
								<div>
									<div>
										{{ entry.firstColumn }}
									</div>
									<div class="mep-text-small">{{ entry.firstColumnDate | date: "dd.MM.yyyy HH:mm:ss" }}</div>
								</div>
							}
						</div>
						<div class="second-column">
							<div>
								<div matTooltip="{{ getCreatedByUser(entry) }}">
									{{ entry.secondColumn }}
								</div>
							</div>
						</div>
						@if (entry.thirdColumn) {
							<div class="third-column">
								<div>
									<div>
										{{ entry.thirdColumn }}
									</div>
								</div>
							</div>
						}
					</div>
					@if (showProfileViewButton) {
						<div class="entry_profile_view" [class.entry_profile_view-empty]="!entry.profileViewId">
							@if (entry.profileViewId) {
								<button
									type="button"
									class="profile-view-button"
									[attr.aria-label]="profileViewButtonTooltip"
									[matTooltip]="profileViewButtonTooltip"
									(click)="onProfileViewButtonClick(entry.profileViewId, $event)"
									[disabled]="disabled"
								>
									<mat-icon>contact_page</mat-icon>
								</button>
							}
						</div>
					}
					@if (possibleSelection.length > 0) {
						<div class="status-column" [ngClass]="{'status-column-with-transfer-button': showTransferToProjectButton}">
							<div class="statusDropDown">
								<mat-select
									class="statusSelect"
									matTooltip="{{ selectionTranslate + entry.status | translate }}"
									[(value)]="entry.status"
									[disabled]="!canChangeStatus"
									(selectionChange)="statusChanged(entry.original, entry.status)"
									(mouseup)="$event.stopPropagation()"
								>
									@for (option of possibleSelection; track option) {
										<mat-option [value]="option.value"
											>{{ selectionTranslate + option.viewValue | translate }}
										</mat-option>
									}
								</mat-select>
							</div>
						</div>
					}
					<div class="entry_toggle">
						@if (entry.toggle !== undefined) {
							<div>
								<mat-checkbox
									matTooltip="{{ toggleTooltip }}"
									[checked]="entry.toggle"
									[disabled]="disabled"
									(change)="checkBoxChanged(entry.original, $event)"
								>
								</mat-checkbox>
							</div>
						}
					</div>
					@if (showTransferToProjectButton) {
						<div class="entry_transfer_to_project">
							<button
								mat-stroked-button
								class="transfer-to-project-button"
								[matTooltip]="getTransferToProjectButtonTooltip(entry)"
								(click)="onTransferToProjectButtonClick(entry.original)"
								[disabled]="disabled"
							>
								<mat-icon>wifi_protected_setup</mat-icon>
								{{ transferToProjectButtonText }}
							</button>
						</div>
					}
					<div class="entry_close">
						@if (entry.secondColumnLink) {
							<mat-icon (click)="entry.secondColumnLink()" class="list-picker-list-download-button">
								download
							</mat-icon>
						}
						@if (!removeDeleteButton(entry)) {
							<mat-icon
								(click)="checkDisabled(delete, entry.original)"
								[ngClass]="{disabled: disabled}"
								class="list-picker-list-close-button"
								>close
							</mat-icon>
						}
					</div>
				</div>
			}
		</div>
	</div>
	@if (!removeAddButton) {
		<div matTooltip="{{ addButtonTooltip }}" class="add" (click)="checkDisabled(add)" [ngClass]="{disabled: disabled}">
			<mat-icon svgIcon="mep_add"></mat-icon>
		</div>
	}
</div>
